import { PREFERENCES_ENDPOINTS } from "./endpoints";
import type { UserPreferences } from "./types";
import { apiRequestWithData } from "../shared";

export default async function getPreferences(): Promise<UserPreferences> {
  return apiRequestWithData<UserPreferences>(PREFERENCES_ENDPOINTS.GET);
}
